export const mergeReorderedProducts = (products, reorderedProducts) => {
  const reordered = Array.isArray(reorderedProducts) ? reorderedProducts : [];
  const reorderedIds = new Set(reordered.map((product) => product.id));
  const reorderedIterator = reordered[Symbol.iterator]();

  return (Array.isArray(products) ? products : []).map((product) => (
    reorderedIds.has(product.id) ? reorderedIterator.next().value : product
  ));
};
